import React, { useMemo, useState } from "react";
import { ColumnType } from "antd/lib/table";

export default function useResizableTableHeader<T>(
  columnConfig: ColumnType<T>[],
  headerMinWidth?: number,
  headerMaxWidth?: number
) {
  const [tableColumns, setTableColumns] = useState<ColumnType<T>[]>(columnConfig);

  const handleResize = (index: number) => (e: any, { size }: any) => {
    const nextColumns = [...tableColumns];
    let width = size.width;
    if (headerMinWidth && headerMaxWidth) {
      if (width > headerMaxWidth) {
        width = headerMaxWidth;
      } else if (width < headerMinWidth) {
        width = headerMinWidth;
      }
    }
    nextColumns[index] = {
      ...nextColumns[index],
      width: width,
    };
    setTableColumns(nextColumns);
  };

  return useMemo(
    () =>
      columnConfig.map((col, index) => ({
        ...col,
        width: tableColumns[index]?.width ?? col.width,
        onHeaderCell: (column: ColumnType<T>) =>
          ({
            width: column.width,
            onResize: handleResize(index),
          } as React.HTMLAttributes<HTMLElement>),
      })),
    [tableColumns, columnConfig]
  );
}
